module.exports = __webpack_public_path__ + "static/0051-bd0ff0c482b2e583b647cea7b9fda132.png";